import CompanyDetails from "@components/company/CompanyDetails"
import { PageLayout } from "@components/ui/PageLayout"
import { companyPageQueryOptions } from "@data/public-page-data-query"
import type { CompanyPageData } from "@site-types/public-page-data"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { isSupportedLocale } from "@utils/locale"
import { localizedRouteHead } from "@utils/route-head"

export const Route = createFileRoute("/$locale/company")({
  beforeLoad: ({ params }) => {
    if (!isSupportedLocale(params.locale)) throw redirect({ to: "/404" })
  },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(companyPageQueryOptions(params.locale as "en" | "ja")),
  head: ({ params }) => {
    const locale = params.locale as "en" | "ja"
    return localizedRouteHead({ locale, page: "company", path: `/${locale}/company` })
  },
  component: RouteComponent,
})

function RouteComponent() {
  const data = Route.useLoaderData()
  return (
    <PageLayout>
      <CompanyPage data={data} />
    </PageLayout>
  )
}

export function CompanyPage({ data }: { data: CompanyPageData }) {
  return <CompanyDetails data={data} />
}
